import api from "./api";

// All log-viewer endpoints live under /log-viewer/api/ and are protected by
// Sanctum token + the `view_logs` permission.  The central `api` axios instance
// already attaches the Bearer token for every request, so no extra setup is
// needed here.

const BASE = "api/log-viewer/api";

// GET /log-viewer/api/hosts
export const listHosts = () =>
  api.get(`${BASE}/hosts`).then((r) => (Array.isArray(r.data) ? r.data : r.data?.hosts ?? []));

// GET /log-viewer/api/folders
export const listFolders = () =>
  api.get(`${BASE}/folders`).then((r) => (Array.isArray(r.data) ? r.data : r.data?.folders ?? []));

// GET /log-viewer/api/files
export const listFiles = () =>
  api.get(`${BASE}/files`).then((r) => (Array.isArray(r.data) ? r.data : r.data?.files ?? []));

// GET /log-viewer/api/logs
// Params: file_identifier (required), query, level, per_page, page
// The package uses "file_identifier" — NOT "file_id".
export const getLogs = (params = {}) =>
  api.get(`${BASE}/logs`, { params }).then((r) => r.data);

// GET /log-viewer/api/files/{id}/download — returns blob
export const downloadFile = (id) =>
  api.get(`${BASE}/files/${id}/download`, { responseType: "blob" });

// DELETE /log-viewer/api/files/{id}
export const deleteFile = (id) =>
  api.delete(`${BASE}/files/${id}`).then((r) => r.data);
